/** This is just a mock class hopefully we can remove after we set up types and backwards-compatibility in clickim */
class PortSelectorMock {
    select() {
        // eslint-disable-next-line no-console
        console.log('\n\t\t\tinternal error - cant use port selector in selenium!!!!\n');
        // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
        return Promise.reject({ reason: 'cant use port selector in selenium!' });
    }
    prepare() { /* mock */ }
    handleLegacyDataCaching() { /* mock */ }
}

export const portSelectorMock = new PortSelectorMock();
